// Format changed to dubai
export const formatAmountUAE = (value) => {
  if (value == null || isNaN(value)) return "-";

  const num = Number(value);

  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(
      num % 1_000_000_000 === 0 ? 0 : 1,
    )}B`;
  }

  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 1)}M`;
  }

  if (num >= 1_000) {
    return `${(num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 1)}K`;
  }

  return num.toLocaleString("en-US");
};

// export const formatAmountIndia = (value) => {
//   if (value == null || isNaN(value)) return "-";

//   const num = Number(value);

//   if (num >= 10000000) {
//     return `${(num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1)}Cr`;
//   }

//   if (num >= 100000) {
//     return `${(num / 100000).toFixed(num % 100000 === 0 ? 0 : 1)}L`;
//   }

//   return num.toLocaleString("en-IN");
// };
